export default __webpack_public_path__ + "static/16-b0ec4733c6a240b2cc6bf3a518359b11.png";